import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, services } from '../../data/companyData';

export default class ServiceFour extends React.Component {
    render(){
        return (
            <>
                <section className="services-one-sec services-one-sec--services">
                    <div className="container">
                        <div className="sec-title text-center">
                            <div className="sec-title__tagline">
                                <span className="left"></span>
                                <h6>Our Services</h6> <span className="right"></span>
                            </div>
                            <h2 className="sec-title__title">Our Professional Services</h2>
                        </div>

                        <div className="row">
                            {services.map((service, index) => (
                                <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay={`${index * 100}ms`} data-wow-duration="1500ms" key={service.slug}>
                                    <div className="services-one__single">
                                        <div className="services-one__single-img">
                                            <img src={assetPath(service.image)} alt={service.title} />
                                        </div>

                                        <div className="services-one__single-content">
                                            <div className="services-one__single-content-title">
                                                <h2><Link to={process.env.PUBLIC_URL + service.path}>{service.title}</Link></h2>
                                            </div>

                                            <div className="services-one__single-content-bottom">
                                                <p>{service.summary}</p>

                                                <div className="services-one__single-btn">
                                                    <Link to={process.env.PUBLIC_URL + service.path} className="thm-btn" data-text="Read More +">Read More +</Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
